const fiatCapabilities = [
  'BENEFICIARIES_CUBIX',
  'BENEFICIARIES_ACH_FEDWIRE',
  'BENEFICIARIES_AED',
  'BENEFICIARIES_CRNOW',
  'BENEFICIARIES_RTP',
  'BENEFICIARIES_FEDNOW',
  'BENEFICIARIES_LATAM',
  'TEMP_LOCAL_BANKING_SUPPORTED_CURRENCIES',
].map(name => ({
  group: 'FIAT',
  name,
}))

const cryptoCapabilities = ['US_STATES_CRYPTO_PAXOS_ENABLED'].map(name => ({
  group: 'CRYPTO',
  name,
}))

export const ACCOUNT_LEVEL_CAPABILITIES = [
  {
    group: 'ACCOUNT',
    name: 'PRINCIPLE_CUSTOMER_COMPANY',
  },
  {
    group: 'ACCOUNT',
    name: 'PRINCIPLE_CUSTOMER_INDIVIDUAL',
  },
  {
    group: 'ACCOUNT',
    name: 'EMBEDDED_CUSTOMER_COMPANY',
  },
  {
    group: 'ACCOUNT',
    name: 'PARTNER_MANAGED_CUSTOMER_COMPANY',
  },
  {
    group: 'ACCOUNT',
    name: 'PARTNER_MANAGED_CUSTOMER_INDIVIDUAL',
  },
  {
    group: 'ACCOUNT',
    name: 'EMBEDDED_CUSTOMER_INDIVIDUAL',
  },
  {
    group: 'ACCOUNT',
    name: 'EARNING_REWARDS',
  },
  {
    group: 'NETWORK',
    name: 'PARTICIPANT',
  },
  {
    group: 'EPC',
    name: 'WALLET_ACTIONS',
  },
  {
    group: 'EPC',
    name: 'EMBEDDED_WALLET_CREATION',
  },
  ...fiatCapabilities,
  ...cryptoCapabilities,
]
